var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.821,
    x2: 459.531,
    y1: 345.893,
    y2: 94.336
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcfdee",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6288,
    stopColor: "#d2f3e4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.074 305.505c18.727 64.003 72.707 194.564 163.922 182.845 91.486-11.755 55.759-129.725 139.508-145.894 36.867-7.118 61.857 56.689 98.806 54.704 47.588-2.557 71.81-49.663 85.108-89.264 28.197-83.968-14.029-226.352-112.859-251.012-86.244-21.519-96.332 83.855-171.322 53.248-42.149-17.203-37.938-68.576-89.272-78.942-155.298-31.359-138.81 189.15-113.891 274.315z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.47 454.758h-398.94c-8.284 0-15-6.716-15-15v-314.267c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15.001-15 15.001z",
    fill: "#2626bc",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 430.758h-398.94c-8.284 0-15-6.716-15-15v-314.267c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15.001-15 15.001z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 86.491h-246.651v344.266h246.651c8.284 0 15-6.716 15-15v-314.266c0-8.284-6.715-15-15-15z",
    fill: "#9fb0fe"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.908,
    cy: 385.322,
    fill: "#8399fe",
    rx: 114.032,
    ry: 10.847
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 155.804v-54.313c0-8.284-6.716-15-15-15h-398.94c-8.284 0-15 6.716-15 15v54.313z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.471 435.757h-398.942c-11.028 0-20-8.972-20-20v-314.265c0-11.028 8.972-20 20-20h398.941c11.028 0 20 8.972 20 20v314.266c.001 11.028-8.971 19.999-19.999 19.999zm-398.942-344.265c-5.514 0-10 4.486-10 10v314.266c0 5.514 4.486 10 10 10h398.941c5.514 0 10-4.486 10-10v-314.266c0-5.514-4.486-10-10-10z",
    fill: "#2626bc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 85.623,
    cy: 123.392,
    fill: "#ff5ba8",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.424,
    cy: 123.392,
    fill: "#fff",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.224,
    cy: 123.392,
    fill: "#02ffb3",
    r: 10.901
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.277 135.64h-136.158v-24.496h136.159c2.761 0 5 2.239 5 5v14.496c-.001 2.761-2.239 5-5.001 5z",
    fill: "#d2deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.789 111.456c-5.286-5.286-13.887-5.286-19.173 0s-5.286 13.887 0 19.173c4.037 4.037 10.003 4.98 14.953 2.852l4.348 4.348c1.952 1.952 5.119 1.952 7.071 0s1.952-5.119 0-7.071l-4.348-4.348c2.129-4.951 1.186-10.917-2.851-14.954zm-12.102 7.071c1.387-1.387 3.644-1.387 5.031 0s1.387 3.644 0 5.031-3.644 1.387-5.031 0c-1.387-1.388-1.387-3.644 0-5.031z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m107.94 215.177h-29.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h29.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#ff7eb8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m146.94 232.634h-68.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h68.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#02ffb3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176.94 287.997h-98.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h98.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#8399fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176.94 270.541h-98.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h98.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#8399fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176.94 305.454h-98.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h98.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#8399fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m155.94 322.911h-77.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h77.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#8399fe"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m134.096 374.201h-51.733c-5.028 0-9.104-4.076-9.104-9.104 0-5.028 4.076-9.104 9.104-9.104h51.733c5.028 0 9.104 4.076 9.104 9.104 0 5.028-4.076 9.104-9.104 9.104z",
    fill: "#ff7eb8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m280.099 186.685h-14.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h14.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m331.908 186.685h-14.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h14.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m383.717 186.685h-14.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h14.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#6583fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m435.526 186.685h-14.681c-2.761 0-5-2.239-5-5s2.239-5 5-5h14.681c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#6583fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m371.766 378.496h-3.496v-42.801h-13.29v18.93c0 4.474-3.626 8.1-8.1 8.1-4.473 0-8.1-3.626-8.1-8.1v-18.93h-13.3v42.801h-3.49c-2.631 0-4.764 2.133-4.764 4.764s2.133 4.764 4.764 4.764h49.776c2.631 0 4.764-2.133 4.764-4.764s-2.133-4.764-4.764-4.764z",
    fill: "#4369fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.698 344.949h-163.64c-2.761 0-5-2.239-5-5v-98.215c0-2.761 2.239-5 5-5h163.64c2.761 0 5 2.239 5 5v98.215c0 2.762-2.239 5-5 5z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.698 327.815v-86.081c0-2.761-2.239-5-5-5h-163.64c-2.761 0-5 2.239-5 5v86.081z",
    fill: "#97ffd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.373 262.638h-39.14c-5.468 0-9.9-4.432-9.9-9.9v-6.103c0-5.468 4.432-9.9 9.9-9.9h39.14c5.468 0 9.9 4.432 9.9 9.9v6.103c0 5.467-4.432 9.9-9.9 9.9z",
    fill: "#02ffb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.267 389.087h-34.15c-3.866 0-7-3.134-7-7v-66.789c0-3.866 3.134-7 7-7h34.15c3.866 0 7 3.134 7 7v66.789c0 3.866-3.134 7-7 7z",
    fill: "#4369fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.118 322.911h48.15v51.564h-48.15z",
    fill: "#97ffd2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m331.373 251.418h-39.14c-5.468 0-9.9-4.432-9.9-9.9v-6.103c0-5.468 4.432-9.9 9.9-9.9h39.14c5.468 0 9.9 4.432 9.9 9.9v6.103c0 5.468-4.432 9.9-9.9 9.9z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m412.628 284.125h-26.895c-2.022 0-3.846-1.218-4.619-3.086-.774-1.869-.347-4.019 1.084-5.449l13.447-13.448c1.951-1.952 5.119-1.952 7.07 0 1.953 1.953 1.953 5.119 0 7.071l-4.912 4.912h14.824c2.762 0 5 2.239 5 5s-2.237 5-4.999 5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m399.181 314.211c-1.279 0-2.56-.488-3.535-1.464-1.953-1.953-1.953-5.119 0-7.071l4.912-4.912h-14.824c-2.762 0-5-2.239-5-5s2.238-5 5-5h26.895c2.022 0 3.846 1.218 4.619 3.086.774 1.869.347 4.019-1.084 5.449l-13.447 13.448c-.977.976-2.257 1.464-3.536 1.464z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m222.876 51.495c-7.88 0-14.291-6.411-14.291-14.291 0-7.881 6.411-14.292 14.291-14.292 7.881 0 14.292 6.411 14.292 14.292 0 7.879-6.411 14.291-14.292 14.291zm0-18.583c-2.366 0-4.291 1.926-4.291 4.292s1.925 4.291 4.291 4.291 4.292-1.925 4.292-4.291-1.926-4.292-4.292-4.292z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.622 485.045c-2.762 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.762 0-5-2.238-5-5s2.238-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.238-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.762 0 5 2.238 5 5s-2.238 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.238 5-5 5z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.939 62.495c-2.762 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.762 0-5-2.238-5-5s2.238-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.238-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.762 0 5 2.238 5 5s-2.238 5-5 5c-3.309 0-6 2.691-6 6 0 2.761-2.238 5-5 5z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff5ba8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.761 478.754c-2.762 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.762 0-5-2.238-5-5s2.238-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.238-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.762 0 5 2.238 5 5s-2.238 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.239 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.8 65.452c-7.88 0-14.291-6.411-14.291-14.291 0-7.881 6.411-14.292 14.291-14.292 7.881 0 14.292 6.411 14.292 14.292 0 7.879-6.411 14.291-14.292 14.291zm0-18.583c-2.366 0-4.291 1.926-4.291 4.292s1.925 4.291 4.291 4.291 4.292-1.925 4.292-4.291-1.926-4.292-4.292-4.292z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/branding.d99a7a0d70d2d4933704e8773383885e.svg";
export { ForwardRef as ReactComponent };